import { useOnboarding } from '../../context/OnboardingContext';
import { applyStyles } from '../../utils/styleUtils';

const H1Element = ({ element }) => {
  const { replaceTemplates } = useOnboarding();
  const style = applyStyles(element);

  return (
    <h1 className="element-h1" style={style}>
      {replaceTemplates(element.text)}
    </h1>
  );
};

export default H1Element;

